import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import {formatCurrency, isPlatformBrowser, isPlatformServer} from '@angular/common';
import { ApiService } from '../shared/api.service';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import { TweenMax } from 'gsap';
import { InfoCuenta } from '../shared/info-cuenta';
import { UploaderService } from '../shared/uploader.service';
import { DeleterService } from '../shared/deleter.service';
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import {rutValidator, numClienteValidator, ValidatorService} from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import {Observable, of, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';

@Component({
  selector: 'app-info-cuenta',
  templateUrl: './info-cuenta.component.html',
  styleUrls: ['./info-cuenta.component.scss']
})
export class InfoCuentaComponent implements OnInit {

  type = 'bar';
  data = {
    labels: [],
    datasets: []
  };
  options = {
    responsive: true,
    maintainAspectRatio: false
  };

  fileCedulaIdentidad: File = null;
  formData: FormGroup;
  submitted = false;
  pasos: any;
  respuesta: any;
  plazo: number;
  datosCliente: any;
  mostrarDatos = false;
  infoCliente = false;
  // Info Cliente
  estadoCliente: any;
  mostrarContacto = false;


  public mimeTypes = ValidatorService.mimeTypes;

  public dataComuna: Array<any>;
  public dataRegion: Array<any>;
  @ViewChild('comuna') comuna;

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private dialog: MatDialog,

  ) {  }

  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnInit() {
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({

      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator], [this.validarNumeroCliente.bind(this)]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      estado_conexion: [''],
      deuda_total: [''],
      f_vencimiento: [''],
      saldo_anterior: [''],
      f_ultimo_pago: [''],
      listaGrafico: [''],
    });
    this.infoCliente = false;
    this.titleService.setTitle('Información de tu cuenta | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Conoce el estado de tu cuenta, detalles de tu consumo y tu historial.' })
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      this.recaptchaV3Service.execute('SubmitSuscripcionBoleta')
        .subscribe(
          (token) => {
            let infoCuenta = new InfoCuenta();
            infoCuenta.numero_cliente = this.formData.value.nCliente;
            infoCuenta.direccion = this.formData.value.direccion;
            /* infoCuenta.id_comuna = this.formData.value.comuna;
            infoCuenta.id_region = this.formData.value.region; */
            infoCuenta.estado_conexion= this.formData.value.estado_conexion;
            infoCuenta.deuda_total= this.formData.value.deuda_total;
            infoCuenta.f_vencimiento= this.formData.value.f_vencimiento;
            infoCuenta.saldo_anterior= this.formData.value.saldo_anterior;
            infoCuenta.f_ultimo_pago= this.formData.value.f_ultimo_pago;
            infoCuenta.token = token;

            const formulario = new FormData();
            formulario.append('data', JSON.stringify(infoCuenta));

            this.apiService.estadoCliente(infoCuenta.numero_cliente).subscribe(r => {
              if( r.respuesta ){
                this.mostrarContacto = true;
                this.estadoCliente = r;
                // Procesar Grafico
                try {

                  this.data.labels = [];
                  this.data.datasets = [];
                  let datasetdata = [];
                  let bg = [];
                  let bc = [];
                  for (let i = r.documentosVenta.ConsultarDocumentosVentaResponse.Documentos.item.length - 1; i >= 0 ; i--)
                  {
                    const element = r.documentosVenta.ConsultarDocumentosVentaResponse.Documentos.item[i];
                    const fecha = element.FechaEmic.toString();
                    const fechaFormato = fecha.substr(0, 4) + '-' + fecha.substr(4, 2);
                    this.data.labels.push(fechaFormato);
                    datasetdata.push(parseInt(element.ConsumoM3, 10));
                    bg.push('rgba(54, 162, 235, 0.2)');
                    bc.push('rgb(54, 162, 235)');
                  }
                  this.data.datasets.push({
                    label: 'Consumo M3',
                    data: datasetdata,
                    backgroundColor: bg,
                    borderColor: bc,
                    borderWith: 1
                  });

                }catch (e){}
                this.mostrarInfoCliente();

              }else{
                this.lightboxDiv('.modal-error');
              }
              this.spinner.hide();

            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }


  validarNumeroCliente(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              console.log(JSON.stringify(res))
              if (res.respuesta) {
                this.mostrarDatos = true;
                this.datosCliente = res;
                this.formData.patchValue({
                  direccion: res.ConsultarDireccionClientePorCtaCtoResponse.Direccion
                });
                this.formData.controls.direccion.disable();
                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
                this.mostrarDatos = false;
              }
              // SI ES INCORRECTO LIMPIAR
              this.formData.patchValue({
                direccion: null
              });
              this.formData.controls.direccion.enable();
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }

  mostrarInfoCliente(){
    this.infoCliente = ! this.infoCliente;
    this.irAlElemento('resultado');
  }

  formatearFecha(fecha){
    if(fecha === '' || fecha == null || fecha === 0) return '';
    return  moment(fecha,'YYYYMMDD').format("DD-MM-YYYY");
  }

  servicioCorte(ConsultarEstadoServicioPorCuentaContratoResponse){

    const estadoOrdenCorte = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenCorte;
    const estadoOrdenReposicion = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenReposicion;
    if ( estadoOrdenCorte === 'CSIM' || estadoOrdenCorte === 'CCCA' || estadoOrdenCorte === 'DVAL' || estadoOrdenCorte === 'IVAL'
     || estadoOrdenCorte === 'CSSE' || estadoOrdenCorte === 'SYSV'){
      if ( estadoOrdenReposicion === 'SOLI' || estadoOrdenReposicion === 'EJEC' ||  estadoOrdenReposicion === 'CASI'){
        return false;
      }
      return true;
    }
    return false;
  }
  servicioReposicion(ConsultarEstadoServicioPorCuentaContratoResponse){
    const estadoOrdenReposicion = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenReposicion;
    if ( estadoOrdenReposicion === 'SOLI' || estadoOrdenReposicion === 'EJEC' ||  estadoOrdenReposicion === 'CASI'){
        return true;
    }
    return false;
  }
  servicioCorteTramite(ConsultarEstadoServicioPorCuentaContratoResponse){
    const estadoOrdenCorte = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenCorte;
    if ( estadoOrdenCorte === 'SOLI' || estadoOrdenCorte === 'EJEC' ||  estadoOrdenCorte === 'CASI'){
      return true;
    }
    return false;
  }

  servicioNormal(ConsultarEstadoServicioPorCuentaContratoResponse){
    const estadoOrdenCorte = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenCorte;
    const estadoOrdenReposicion = ConsultarEstadoServicioPorCuentaContratoResponse.EstadoOrdenReposicion;
    if (estadoOrdenCorte === '' && estadoOrdenReposicion === ''){
      return true;
    }
    return false;
  }

  formatCLP(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  irAlElemento(id: string) {
    TweenMax.to('#resultado', 0.5, {
      width: '50%', onComplete: () => {

        $("#resultado")[0].scrollIntoView();
      }
    });
  }
}
